<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon icon="SettingsIcon" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer" @click="runCommandNow"/>
    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord"/>
    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord"/>
  </div>
</template>

<script>
export default {
  name: 'CellRendererActionsFailing',
  methods: {
    editRecord() {
      this.item = this.params.data;
      this.$router.push("/products/edit/" + this.params.data.product.id).catch(() => {
      })
    },
    runCommandNow() {
      this.item = this.params.data.product;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Επιβεβαίωση`,
        text: 'Θέλετε να εκτελέσετε την εργασία για αυτό το προϊόν τώρα;',
        acceptText: 'Εκτέλεση εργασίας',
        cancelText: 'Ακύρωση',
        accept: this.runCommandNowOnDemand
      })
    },
    runCommandNowOnDemand() {
      let obj = {
        productId: this.params.data.product.id
      }
      this.$store.dispatch('fetchCommandOnDemand',obj)
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Επιβεβαίωση διαγραφής',
        text: `Πρόκειται να διαγράψετε την εγγραφή "${this.params.data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Διαγραφή'
      })
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      // this.showDeleteSuccess()
      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch("deleteProductFailing", this.params.data.id)
          .then((response) => {
            if(response === 'Successfully Deleted')
            this.showDeleteSuccess()
            this.$store.dispatch('fetchProductsUrlsFailed')
          })
          .catch(err => {
            console.error(err)
          })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'Η εγγραφή διαγράφηκε',
        position: 'top-right',
        text: 'Η επιλεγμένη εγγραφή διαγράφηκε με επιτυχία'
      })
    }
  }
}
</script>
